import TextBox from 'devextreme-react/text-box';
import DataGrid, { Column, Format } from 'devextreme-react/data-grid';
import { formatNumber } from 'devextreme/localization';
import { useContext } from 'react';
import { POCreditMemoContext } from '../context/POCreditMemoContext';

export default function CreditMemoProducts() {

    const { creditMemo } = useContext(POCreditMemoContext);

    return (
        <>
            <DataGrid
                dataSource={creditMemo.details.products}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                showColumnLines={true}
                columnAutoWidth={true}
                wordWrapEnabled={true}
                keyExpr={'creditMemoProductID'}
                className="grid-with-header"
            >
                <Column
                    dataField={'sku'}
                    caption={'SKU'}
                    dataType="string"
                />
                <Column
                    dataField={'productDescription'}
                    caption={'Product'}
                    dataType="string"
                />
                <Column
                    dataField={'shippedDate'}
                    caption={'Shipped Date'}
                    dataType="date"
                />
                <Column
                    dataField={'description'}
                    caption={'Description'}
                    dataType="string"
                />
                <Column
                    dataField={'quantity'}
                    caption={'Quantity'}
                    dataType="number"
                />
                <Column
                    dataField={'price'}
                    caption={'Price'}
                    dataType="number"
                >
                    <Format type="currency" precision={2} ></Format>
                </Column>
                <Column
                    dataField={'amount'}
                    caption={'Amount'}
                    dataType="number"
                >
                    <Format type="currency" precision={2} ></Format>
                </Column>
            </DataGrid>
            <div className='dx-clearfix'></div>
            <table className='summary-table'>
                <tbody>
                    <tr>
                        <td>Shipping Charge Description:</td>
                        <td style={{ paddingLeft: '10px', paddingRight: '30px' }}>
                            <TextBox readOnly={true} value={creditMemo.details.shippingChargeDescription} width={300} />
                        </td>
                        <td>Shipping Charge Amount:</td>
                        <td>
                            {formatNumber(creditMemo.details.shippingChargeAmount ?? 0, { type: 'currency', precision: 2 })}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}></td>
                        <td>Balance:</td>
                        <td>
                            {formatNumber(creditMemo.details.balance ?? 0, { type: 'currency', precision: 2 })}
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}
